import request from '@/utils/request'

//取消接单
export function cancellationOrder(){  
    return request({
       url:'/webapi/authority/order/cancelOrder',
       method: 'GET',
    })
}

//等待接单
export function WaitingOrder(){
    return request({
        url:'/webapi/authority/order/waitOrder',
        method: 'GET',
    })
}

//司机已接单
export function receivOrder(){
    return request({
        url:'/webapi/authority/order/receivOrder',
        method: 'GET',
    })
}
